export default __webpack_public_path__ + "static/logoFooter-a8df4355ca7b1e3504392578adc7892b.svg";